import { useEffect } from 'react';

import { useLocation, useNavigate } from '@tanstack/react-router';
import { isChrome, isSafari } from 'react-device-detect';

export function BrowserGuard() {
    const navigate = useNavigate();
    const { pathname } = useLocation();

    useEffect(() => {
        if (isChrome || isSafari) return;
        if (pathname === '/unsupported-browser') return;
        void navigate({ to: '/unsupported-browser', replace: true });
    }, [pathname, navigate]);

    return null;
}
